<template>
  <SourceFiltersSelector
    :filter="loadTopics"
    :model-value="topicFilters"
    placeholder="Name"
    @item="addTopicFilter"
    @query="query = $event"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";

import { ErrorDialog } from "shared/boot/alert";
import { track } from "shared/boot/analytics";
import { getLocaleText } from "shared/boot/i18n";
import useSourceFilters from "shared/composables/useSourceFilters";
import { OutreachTopic } from "shared/resources";

import SourceFiltersSelector, {
  type SourceFiltersSelectorFilterResponse,
  type SourceFiltersSelectorFilterResponseItem,
} from "./SourceFiltersSelector.vue";

const PAGE_SIZE = 50;

const { topicFilters } = useSourceFilters();

const { addFilter } = useSourceFilters();
const query = ref<string>("");

async function loadTopics(
  index: number
): Promise<
  SourceFiltersSelectorFilterResponse<SourceFiltersSelectorFilterResponseItem>
> {
  try {
    const filter = {
      name: { match: query.value },
    };

    const response = await OutreachTopic.where(filter)
      .page(index + 1)
      .per(PAGE_SIZE)
      .stats({ total: "count" })
      .all();

    return {
      items: response.data.map((topic) => ({ id: topic.id, name: topic.name })),
      pages: Math.floor(response.meta.stats.total.count / PAGE_SIZE),
    };
  } catch (error) {
    ErrorDialog(
      getLocaleText("modals.outreach_topics_modal.load_contacts_error"),
      error
    );

    return {
      items: [],
      pages: 0,
    };
  }
}

function addTopicFilter(topic: OutreachTopic): void {
  addFilter({
    type: "topic",
    value: {
      id: Number(topic.id!),
      name: topic.name,
    },
  });

  track("Add sector in Advanced Source Filter");
}
</script>
